import { AuthGate } from '@entities/auth'
import {
  LocalReadingHistory,
  MenuSection,
  PaymentHistorySection,
  ProfileSection,
  SavedInfoSection,
  ServerReadingHistory,
} from '@features/mypage'
import { PosthogPageView } from '@shared/lib/posthog'
import { AppHeader } from '@shared/ui/app-header'
import { Button } from '@shared/ui/button'
import { Footer } from '@shared/ui/footer'
import { LoadingScreen } from '@shared/ui/loading-screen'
import { NoSsrSuspense } from '@shared/ui/no-ssr-suspense'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/mypage')({
  component: () => (
    <PosthogPageView event="view_mypage">
      <NoSsrSuspense fallback={<LoadingScreen />}>
        <MyPage />
      </NoSsrSuspense>
    </PosthogPageView>
  ),
  ssr: false,
})

function MyPage() {
  const navigate = useNavigate()

  return (
    <>
      <AppHeader
        leading={<AppHeader.Back />}
        title="마이페이지"
        variant="blur"
        divider="elevation"
      />

      <div className="flex-1 bg-bg-base pb-content-bottom pt-6">
        <AuthGate
          fallback={
            <div className="px-4 mb-section-gap">
              <Button
                variant="primary"
                size="lg"
                className="mb-4 w-full"
                onClick={() => {
                  void navigate({ to: '/login' })
                }}
              >
                로그인하고 내 분석 기록 저장하기
              </Button>
            </div>
          }
        >
          <ProfileSection />
        </AuthGate>

        <SavedInfoSection />

        <AuthGate fallback={<LocalReadingHistory />}>
          <ServerReadingHistory />
        </AuthGate>

        <AuthGate fallback={null}>
          <PaymentHistorySection />
        </AuthGate>

        <MenuSection />
      </div>

      <Footer />
    </>
  )
}
